import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import BackButton from './BackButton';
const ResetPassword = () => {
  const { token: urlToken } = useParams();
  const [token, setToken] = useState(urlToken || '');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
   const navigate = useNavigate();

  const handleResetPassword = async () => {
    try {
      const response = await axios.post('https://backend.aubattle.com/api/auth/reset-password', { token, newPassword });
      setMessage(response.data.message);
      setError('');
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError('Invalid or expired token');
      setMessage('');
    }
  };

  return (
    <div className="forget-password-container">
      <BackButton/>
      <h2>Reset Password</h2>
      <input
        type="text"
        placeholder="Enter token"
        value={token}
        onChange={(e) => setToken(e.target.value)}
      />
      <input
        type="password"
        placeholder="Enter new password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <button onClick={handleResetPassword}>Reset Password</button>
      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default ResetPassword;
